import React, { useState, useRef, useCallback, useLayoutEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import NeutralToggle from '../controls/NeutralToggle';
import Dropdown from 'react-bootstrap/Dropdown';
import NumericInput from 'react-numeric-input';
import { Content } from '../DataStructures';
import { useForceUpdate } from '../util';
const maxVectors = 6;
export default function Table(props) {
  var _dataProps$style$vert, _dataProps$style;
  const dataProps = props.data.props;
  const forceUpdate = useForceUpdate();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of Rows: ")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
    size: "1",
    min: 2,
    max: maxVectors,
    value: dataProps.contents.length,
    onChange: e => {
      if (e) {
        if (e < 2) {
          e = 2;
        } else if (e > maxVectors) {
          e = maxVectors;
        }
        let delta = e - dataProps.contents.length;
        if (delta > 0) {
          const colLength = dataProps.contents[dataProps.contents.length - 1].length;
          let defaultArray = [];
          for (let i = 0; i < colLength; i++) {
            defaultArray.push({
              data: new Content(`Col${i + 1}`)
            });
          }
          for (let i = 0; i < Math.abs(delta); ++i) {
            dataProps.contents.push(defaultArray);
          }
        } else if (delta < 0) {
          dataProps.contents.splice(delta);
        }
        forceUpdate();
        props.onChanged();
      }
    }
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of Cols:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
    size: "1",
    min: 2,
    max: 6,
    value: dataProps.contents[dataProps.contents.length - 1].length,
    onChange: e => {
      const colLength = dataProps.contents[dataProps.contents.length - 1].length;
      if (e) {
        if (e < 2) {
          e = 2;
        } else if (e > maxVectors) {
          e = maxVectors;
        }
        let delta = e - colLength;
        if (delta > 0) {
          dataProps.contents.map((v, i) => {
            for (let i = 0; i < Math.abs(delta); ++i) {
              v.push({
                data: new Content(`Col${e}`)
              });
            }
          });
        } else if (delta < 0) {
          dataProps.contents.map((v, i) => {
            v.splice(delta);
          });
        }
        forceUpdate();
        props.onChanged();
      }
    }
  })))), /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Cell Content Alignment:"), " "), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, (_dataProps$style$vert = (_dataProps$style = dataProps.style) === null || _dataProps$style === void 0 ? void 0 : _dataProps$style.verticalAlign) !== null && _dataProps$style$vert !== void 0 ? _dataProps$style$vert : "middle"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.style = dataProps.style || {};
      dataProps.style.verticalAlign = "middle";
      forceUpdate();
      props.onChanged();
    }
  }, "Center"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.style = dataProps.style || {};
      dataProps.style.verticalAlign = "top";
      forceUpdate();
      props.onChanged();
    }
  }, "Top"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.style = dataProps.style || {};
      dataProps.style.verticalAlign = "bottom";
      forceUpdate();
      props.onChanged();
    }
  }, "Bottom")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Contents Table:")), /*#__PURE__*/React.createElement("table", {
    style: {
      tableLayout: "fixed",
      borderCollapse: "collapse",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, dataProps.contents.map((v, i) => {
    return /*#__PURE__*/React.createElement("tr", null, v.map((value, index) => {
      var _value$colSpan;
      return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
        class: "btn btn-primary btn-sm",
        variant: "primary",
        onClick: () => {
          let fullPath = props.path.slice();
          fullPath.push("props", "contents", i, index, "data");
          props.scopeToItem(fullPath);
        }
      }, "Edit ", `R${i + 1}C${index + 1}`), (i === 0 || index === 0) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Header?")), /*#__PURE__*/React.createElement(NeutralToggle, {
        style: {
          display: 'block'
        },
        optionTrue: "Yes",
        optionFalse: "No",
        value: value.isHeader,
        onChange: v => {
          value.isHeader = v;
          forceUpdate();
          props.onChanged();
        }
      })), value.isHeader && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Length:")), /*#__PURE__*/React.createElement(NumericInput, {
        size: "1",
        maxLength: "1",
        style: {
          input: {
            display: "block"
          }
        },
        min: 1,
        max: dataProps.contents[dataProps.contents.length - 1].length,
        value: (_value$colSpan = value.colSpan) !== null && _value$colSpan !== void 0 ? _value$colSpan : 1,
        onChange: e => {
          if (e) {
            const colLength = dataProps.contents[dataProps.contents.length - 1].length;
            if (e < 1) {
              e = 1;
            } else if (e > colLength) {
              e = colLength;
            }
            value.colSpan = e;
            forceUpdate();
            props.onChanged();
          }
        }
      })));
    }));
  }))))));
}